import { TabInterface } from '../../Interfaces/TabInterface'
import { SecondaryLayout, TabGroup } from '../../share/Components'
import IHIO from './IHIO/IHIO'
import Tamin from './Tamin/Tamin'

const Reports = () => {
  const items: Array<TabInterface> = [
    {
      title: 'بیمه سلامت',
      index: true,
      icon: 'rayteb-ihio',
      className: {
        titleClass: 'text-xs',
        iconClass: 'text-2xl',
        className: 'py-2 px-4 ',
      },
      element: <IHIO />,
    },
    // {
    //   title: 'تامین اجتماعی',
    //   index: true,
    //   icon: 'rayteb-tamin',
    //   className: {
    //     titleClass: 'text-xs',
    //     iconClass: 'text-2xl',
    //     className: 'py-2 px-4 ',
    //   },
    //   element: <Tamin />,
    // },
  ]
  return (
    <>
      <TabGroup items={items} className='border-t border-primaryLight' />
    </>
  )
}

Reports.Layout = ({ children }) => {
  return <SecondaryLayout title={'گزارش ها'}>{children}</SecondaryLayout>
}
export default Reports
